import { requestIdleCallback } from '@theme/utilities';

/**
 * @typedef {object} Variant
 * @property {string | null} option1
 * @property {string | null} option2
 * @property {string | null} option3
 * @property {{ src: string } | null} featured_image
 */

/**
 * Updates product card images based on the selected colour variant.
 */
export function updateVariantImages() {
  console.log('[Variant Image Handler] Running updateVariantImages...');
  const productCards = document.querySelectorAll('product-card');
  const urlParams = new URLSearchParams(window.location.search);
  const colourFilter = urlParams.get('filter.v.option.colour');

  console.log(`[Variant Image Handler] colour filter found: "${colourFilter}"`);
  if (!colourFilter) {
    console.log('[Variant Image Handler] No colour filter applied. Exiting.');
    return;
  }

  console.log(`[Variant Image Handler] Found ${productCards.length} product cards.`);

  productCards.forEach((card, index) => {
    console.log(`[Variant Image Handler] Processing card ${index + 1}...`);
    const variantsJson = card.querySelector('[data-product-variants]');
    if (!variantsJson || !variantsJson.textContent) {
      console.log(`[Variant Image Handler] Card ${index + 1} has no variant JSON. Skipping.`);
      return;
    }

    /** @type {Variant[]} */
    const variants = JSON.parse(variantsJson.textContent);
    console.log(`[Variant Image Handler] Card ${index + 1} variants:`, variants);

    const matchingVariant = variants.find(
      (variant) =>
        variant.option1 === colourFilter || variant.option2 === colourFilter || variant.option3 === colourFilter
    );

    console.log(`[Variant Image Handler] Card ${index + 1} matching variant for "${colourFilter}":`, matchingVariant);

    if (matchingVariant && matchingVariant.featured_image) {
      const image = /** @type {HTMLImageElement | null} */ (card.querySelector('.product-media__image'));
      console.log(`[Variant Image Handler] Card ${index + 1} image element:`, image);
      if (image) {
        console.log(`[Variant Image Handler] Card ${index + 1} UPDATING image src to: ${matchingVariant.featured_image.src}`);
        image.srcset = `${matchingVariant.featured_image.src}&width=550`;
      }
    }
  });
  console.log('[Variant Image Handler] Finished processing cards.');
}

// Run on initial page load
document.addEventListener('DOMContentLoaded', () => {
  updateVariantImages();
});

// Run after section rendering (e.g., after filtering)
document.addEventListener('shopify:section:load', () => {
  updateVariantImages();
});

// Listen for when new products are added to the DOM (for infinite scrolling)
const observer = new MutationObserver((mutations) => {
  // Check if any new product cards were added
  let hasNewProductCards = false;
  
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const element = /** @type {Element} */ (node);
          // Check if the added element is a product card or contains product cards
          if (element.tagName === 'PRODUCT-CARD' || element.querySelector('product-card')) {
            hasNewProductCards = true;
          }
        }
      });
    }
  });
  
  if (hasNewProductCards) {
    console.log('[Variant Image Handler] New product cards detected, updating images...');
    // Use setTimeout to avoid blocking the main thread during scrolling
    setTimeout(() => {
      updateVariantImages();
    }, 100);
  }
});

// Start observing the document body for new product cards
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Clean up observer when the page unloads
window.addEventListener('beforeunload', () => {
  observer.disconnect();
});
